import { useQuery } from "@tanstack/react-query";
import useApi from "../../../../../../utils/api";

export const useQualificationQuery = (user: any) => {
    const { authGet } = useApi();
    const skillQuery = useQuery({
        queryKey: [`/users/${user?.id}/skills`],
        queryFn: ({ queryKey }: any) => authGet(queryKey[0]),
        enabled: !!user?.id,
    });

    const licenseQuery = useQuery({
        queryKey: [`/users/${user?.id}/licenses`],
        queryFn: ({ queryKey }: any) => authGet(queryKey[0]),
        enabled: !!user?.id,
    });

    const certificationsQuery = useQuery({
        queryKey: [`/users/${user?.id}/certifications`],
        queryFn: ({ queryKey }: any) => authGet(queryKey[0]),
        enabled: !!user?.id,
    });

    return {
        skillQuery,
        licenseQuery,
        certificationsQuery
    };
}
